import { ELotSaleType, ILot, ITokenOriginalView } from '../types/lot'
import { ECardType, ICard } from '../types/card'
import { Cards } from './UI/Card/List'
import { ContractVersion } from '../utils/modules/contract/types'
import { PremiumDetail } from './UI/Card/Premium'

interface IPropsList {
    tokens: ITokenOriginalView[]
}
interface IPropsDetail {
    token: ITokenOriginalView
}

export function dataFromPremiumToCard(token: ITokenOriginalView): ICard {
    const lot = (token.Lots || [])[0] as ILot | undefined
    // const { auth } = useTypedSelector(s => s)
    return {
        cardType: ECardType.premium,
        id: token.id,
        name: token.name,
        description: token.description,
        copiesTotal: token.copiesTotal,
        minimalCost: lot?.minimalCost,
        copiesSold: lot?.copiesSold,
        contents: token.TokenMedias || [],
        typeFile: token.contentType,
        status: token.status,
        User: token.User,
        TokensNFT: token.TokensNFT,
        moderatorMessage: token.moderatorMessage || '',
        isUseCensored: token.isUseCensored,
        Lots: token.Lots,
        isCommercial: token.isCommercial,
        marketplaceVer: lot?.marketplaceVer as ContractVersion,
        saleType: lot?.type as ELotSaleType | undefined,
        creatorReward: token.creatorReward,
    }
}

export function fromPremiumToCard(tokens: ITokenOriginalView[]) {
    return tokens.map((t) => dataFromPremiumToCard(t))
}

export const List = ({ tokens }: IPropsList) => {
    const cards: ICard[] = tokens.map((l) => dataFromPremiumToCard(l))
    return <Cards cards={cards}></Cards>
}

export const Detail = ({ token }: IPropsDetail) => {
    const card: ICard = dataFromPremiumToCard(token)
    return <PremiumDetail card={card}></PremiumDetail>
}
